const headers = document.querySelectorAll('.accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const openItem = document.querySelector('.accordion-header.active');
      const content = header.nextElementSibling;

      // Close currently open item (if it's not the one clicked)
      if (openItem && openItem !== header) {
        openItem.classList.remove('active');
        const openContent = openItem.nextElementSibling;
        openContent.style.maxHeight = null;
        openContent.classList.remove('open');
      }

      // Toggle the clicked one
      header.classList.toggle('active');
      if (header.classList.contains('active')) {
        content.style.maxHeight = 500 + 'px';
        content.classList.add('open');
      } else {
        content.style.maxHeight = null;
        content.classList.remove('open');
      }
    });
  });